import React, {useEffect, useState} from "react";
import {DEFAULT_PRODUCT_BLOG_POST_TAB, PRODUCT_BLOG_POST_TAB_LIST} from "../../constants/shopify-blog.constant";
import {XMarkIcon} from "@heroicons/react/24/solid";
import ShowTabsList from "../../../common/ui/show-tabs-list";
import ShopifyBlogProductList from "./shopify-blog-product-list";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {searchPromptsWithSearchCriteria} from "../../../content/services/prompt-data-service";
import _ from "lodash";
import ProductBlogPostContent from "./product-blog-post-content";
import {addSingleBlogPost, searchBlogPostsWithSearchCriteria} from "../../../content/services/blog-post-data-service";
import {SAVE_BLOG_POST_TIME_DELAY} from "../../../content/constants/blog.constant";
import {updateSingleDesign} from "../../../design/services/design-data-service";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import FeaturedImageEditor from "./featured-image-editor";
import {
    addSingleBlogPostContent,
    searchBlogPostContentsWithSearchCriteria
} from "../../../content/services/blog-post-content-data-service";
import {
    addSingleFeaturedImage,
    searchFeaturedImagesWithSearchCriteria
} from "../../../content/services/featured-image-data-service";
import {extractCollectionsList} from "../../utils/product-util";
import ShopifyBlogArticle from "./shopify-blog-article";
import {
    getSingleDesignVariantDetail
} from "../../../design/services/design-variant-data-service";
import {searchShopifyBlogs} from "../../services/shopify-blog-data-service";
import ProductBlogPostWriter from "../product-blog-post/product-blog-post-writer";


const tabsList = PRODUCT_BLOG_POST_TAB_LIST;

const DesignProductBlogPost = ({
                                   productsList,
                                   selectedDesign,
                                   setSelectedDesign,
                                   promptsList,
                                   setPromptsList
                               }) => {
    const [showModal, setShowModal] = useState(false);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [selectedTab, setSelectedTab] = useState(DEFAULT_PRODUCT_BLOG_POST_TAB);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [blogPost, setBlogPost] = useState(null);
    const [blogPostContent, setBlogPostContent] = useState(null);
    const [featuredImage, setFeaturedImage] = useState(null);
    let [changesCount, setChangesCount] = useState(0);
    const [selectedProductImageList, setSelectedProductImageList] = useState([]);
    const [collectionsList, setCollectionsList] = useState(null);
    const [shopifyBlogsList, setShopifyBlogsList] = useState(null);

    useEffect(() => {
        if (showModal) {
            init();
        }
    }, [showModal]);

    useEffect(() => {
        if (!_.isEmpty(selectedProductImageList)) {
            incrementChangesCount()
        }
    }, [selectedProductImageList, blogPost?.status]);

    useEffect(() => {
        if (selectedDesign) {
            getBlogPostByDesign();
        }
    }, [selectedDesign?.id]);

    const init = async () => {
        setDataFetchInProgress(true);
        setSelectedTab(DEFAULT_PRODUCT_BLOG_POST_TAB);

        setSelectedProductImageList(selectedDesign.productImages || []);
        await getBlogPostContentByPostId(selectedDesign?.blogPost?.id);
        await getFeaturedImageByPostId(selectedDesign?.blogPost?.id);

        // await getFirstDesignVariant();
        await getPromptList();
        await getShopifyBlogList();
        setCollectionsList(extractCollectionsList(productsList));
    }

    const getShopifyBlogList = async () => {
        const blogListResult = await searchShopifyBlogs([]);
        setShopifyBlogsList(blogListResult);
    }

    const getPromptList = async () => {
        let existingPromptsList = [];

        if (!_.isEmpty(promptsList)) {
            existingPromptsList = [...promptsList];
        }

        if (_.isEmpty(existingPromptsList)) {
            const searchCriteriaList = [
                {
                    field: 'type',
                    condition: '==',
                    value: 'Product Blog'
                },
                {
                    field: 'status',
                    condition: '==',
                    value: 'Enabled'
                }
            ];

            const promptListResult = await searchPromptsWithSearchCriteria(searchCriteriaList);
            setPromptsList(promptListResult);
        }
    }

    const getFirstDesignVariant = async () => {
        if (selectedDesign?.variants?.length > 0) {
            const designVariant = await getSingleDesignVariantDetail(selectedDesign.variants[0].id);
            let tags = _.join(_.compact(_.split(designVariant.instagramTags, ' ')), ', ');
            tags = _.join(_.split(tags, '#'), '');

            const existingDesign: any = {...selectedDesign};
            existingDesign.designTags = tags;
            setSelectedDesign(existingDesign);
        }
    }

    const getBlogPostByDesign = async () => {
        let currentBlogPost;
        const searchCriteriaList = [
            {
                field: 'type',
                condition: '==',
                value: 'Product Blog'
            },
            {
                field: 'designId',
                condition: '==',
                value: selectedDesign.id
            }
        ];

        const blogPostResults = await searchBlogPostsWithSearchCriteria(searchCriteriaList);

        if (!_.isEmpty(blogPostResults)) {
            currentBlogPost = blogPostResults[0];
        } else {
            const newBlogPost: any = {
                title: '',
                type: 'Product Blog',
                status: 'New',
                designId: selectedDesign.id,
            }

            const newBlogPostResult = await addSingleBlogPost(newBlogPost);
            newBlogPost.id = newBlogPostResult.id;
            currentBlogPost = newBlogPost;
        }

        setBlogPost(currentBlogPost);

        if (!selectedDesign?.blogPost || selectedDesign?.blogPost?.status !== currentBlogPost.status) {
            incrementChangesCount();
        }
    }

    const getBlogPostContentByPostId = async (blogPostId) => {
        const searchCriteriaList = [{
            field: 'blogPostId',
            condition: '==',
            value: blogPostId
        }];
        const blogPostContentListResult = await searchBlogPostContentsWithSearchCriteria(searchCriteriaList);
        let existingBlogPostContent: any = {};

        if (blogPostContentListResult.length === 0) {
            existingBlogPostContent = {
                blogPostId: blogPostId,
            }

            const newBlogPostContentResult = await addSingleBlogPostContent(existingBlogPostContent);
            existingBlogPostContent.id = newBlogPostContentResult.id;
            setBlogPostContent(existingBlogPostContent);
        } else {
            existingBlogPostContent = blogPostContentListResult[0]
        }

        console.log('blogPostContentListResult', blogPostContentListResult);
        console.log('existingBlogPostContent', existingBlogPostContent);

        setBlogPostContent(existingBlogPostContent);
    }

    const getFeaturedImageByPostId = async (blogPostId) => {
        const searchCriteriaList = [{
            field: 'blogPostId',
            condition: '==',
            value: blogPostId
        }];
        const featuredImageListResult = await searchFeaturedImagesWithSearchCriteria(searchCriteriaList);
        let existingFeaturedImage: any = {};

        if (featuredImageListResult.length === 0) {
            existingFeaturedImage = {
                blogPostId: blogPostId,
            }

            const newFeaturedImageResult = await addSingleFeaturedImage(existingFeaturedImage);
            existingFeaturedImage.id = newFeaturedImageResult.id;
            setFeaturedImage(existingFeaturedImage);
        } else {
            existingFeaturedImage = featuredImageListResult[0]
        }

        setFeaturedImage(existingFeaturedImage);
        setDataFetchInProgress(false);
    }

    const handleCloseAction = () => {
        setShowModal(false);
    }

    const incrementChangesCount = () => {
        setChangesCount(++changesCount);
    }

    const resetChangesCount = () => {
        setChangesCount(0);
    }

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {
                if (changesCount > 0) {
                    resetChangesCount();
                    updateBlogDetailsInDesign();
                }
            }, SAVE_BLOG_POST_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    }, [changesCount]);

    const updateBlogDetailsInDesign = async () => {
        const existingDesign: any = {...selectedDesign};
        existingDesign.productImages = [...selectedProductImageList];

        const existingBlogPost: any = {...blogPost};
        if (!_.isEmpty(existingBlogPost)) {
            if (_.isEmpty(existingDesign.blogPost)) {
                existingDesign.blogPost = {};
            }

            existingDesign.blogPost.id = existingBlogPost.id;
            existingDesign.blogPost.title = existingBlogPost.title;
            existingDesign.blogPost.status = existingBlogPost.status;
        }

        setSelectedDesign(existingDesign);
        await updateSingleDesign(existingDesign);
    }

    return (
        <>
            <button
                className="button-sky px-3 py-2 mx-1"
                onClick={() => setShowModal(true)}>
                Design Product Blog Post {blogPost &&
                <span
                    className={`text-sm ml-1 px-1 ${blogPost?.status === 'Published' ? 'button-green' : 'button-gray-outline'}`}>{blogPost?.status}</span>}
            </button>

            {showModal ? (
                <>
                    <div
                        className="w-full h-full justify-center items-center flex overflow-x-hidden overflow-y-hidden fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-full h-full">

                            <div
                                className="border-0 shadow-lg relative flex flex-col w-full h-full bg-white outline-none focus:outline-none">

                                <div className="flex items-center justify-between p-5">
                                    <div className={'flex items-center justify-start'}>
                                        <h3 className="text-xl ml-2 font-bold">
                                            Design Product Blog Post Content
                                        </h3>
                                    </div>

                                    <h3 className="ml-4 text-xl font-bold text-center text-purple-500">
                                        <div>
                                            {selectedDesign?.name}
                                        </div>
                                        <div className={'font-light'}>
                                            {blogPost?.title}
                                            {blogPost?.status &&
                                                <span className="button-purple-outline px-2 ml-2">
                                                    <span className={'text-lg font-semibold'}>{blogPost?.status}</span>
                                                </span>
                                            }
                                        </div>
                                    </h3>

                                    <div className="-mt-1">
                                        <ShowProgressSpinner
                                            dataFetchInProgress={saveInProgress || dataFetchInProgress}/>
                                    </div>

                                    <div className={'mt-2 flex items-center justify-start'}>
                                        <button
                                            className="button-outline-gray px-3 py-2 m-1"
                                            onClick={handleCloseAction}>
                                            <div className="">
                                                <XMarkIcon className="h-6 w-6"/>
                                            </div>
                                        </button>
                                    </div>
                                </div>

                                <div className="relative h-full flex flex-wrap justify-start">

                                    <div className="w-full h-full">

                                        <div>
                                            <ShowTabsList
                                                setSelectedTab={setSelectedTab}
                                                selectedTab={selectedTab}
                                                tabsList={tabsList}/>
                                        </div>


                                        <div className="flex bg-gray-100 h-full w-full px-6">
                                            {selectedTab?.key === 'blog-post-content' && promptsList && shopifyBlogsList && blogPostContent && collectionsList &&
                                                <>
                                                    <div className="flex flex-wrap w-full">
                                                        <ProductBlogPostWriter
                                                            contentTags={_.join(selectedDesign?.designTags, ', ')}
                                                            shopifyBlogsList={shopifyBlogsList}
                                                            productsList={productsList}
                                                            collectionsList={collectionsList}
                                                            setSaveInProgress={setSaveInProgress}
                                                            blogPost={blogPost}
                                                            setBlogPost={setBlogPost}
                                                            blogPostContent={blogPostContent}
                                                            setBlogPostContent={setBlogPostContent}
                                                            selectedProductImageList={selectedProductImageList}
                                                            setSelectedProductImageList={setSelectedProductImageList}
                                                        />

                                                        {/*<ProductBlogPostContent
                                                            contentTags={selectedDesign?.designTags}
                                                            promptsList={promptsList}
                                                            shopifyBlogsList={shopifyBlogsList}
                                                            productsList={productsList}
                                                            collectionsList={collectionsList}
                                                            selectedProductImageList={selectedProductImageList}
                                                            setSaveInProgress={setSaveInProgress}
                                                            blogPost={blogPost}
                                                            setBlogPost={setBlogPost}
                                                            blogPostContent={blogPostContent}
                                                            setBlogPostContent={setBlogPostContent}/>*/}
                                                    </div>
                                                </>
                                            }

                                            {/*{selectedTab?.key === 'product-list' && promptsList &&
                                                <>
                                                    <div className="flex flex-wrap w-full">
                                                        <ShopifyBlogProductList
                                                            contentTags={selectedDesign?.designTags}
                                                            dataFetchInProgress={dataFetchInProgress}
                                                            productsList={productsList}
                                                            selectedProductImageList={selectedProductImageList}
                                                            setSelectedProductImageList={setSelectedProductImageList}
                                                            promptsList={promptsList}/>
                                                    </div>
                                                </>
                                            }*/}

                                            {selectedTab?.key === 'featured-image' &&
                                                <>
                                                    <div className="flex flex-wrap w-full">
                                                        <FeaturedImageEditor
                                                            productImageList={selectedProductImageList}
                                                            productsList={productsList}
                                                            selectedDesign={selectedDesign}
                                                            featuredImage={featuredImage}
                                                            setFeaturedImage={setFeaturedImage}/>
                                                    </div>
                                                </>
                                            }

                                            {selectedTab?.key === 'shopify-blog-article' &&
                                                <>
                                                    <div className="w-full">
                                                        <ShopifyBlogArticle
                                                            setSaveInProgress={setSaveInProgress}
                                                            featuredImage={featuredImage}
                                                            blogPost={blogPost}
                                                            setBlogPost={setBlogPost}
                                                            blogPostContent={blogPostContent}/>
                                                    </div>
                                                </>
                                            }
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default DesignProductBlogPost
